module.exports = __webpack_public_path__ + "img/Página_MisterGlobal.c0af177d.jpg";